/**
 * GraphQL query strings for the User Profile service.
 * Matches the schema at user-profile/packages/schema.graphql.
 */

/** Fragment for contact value union — handles both scalar and address types */
const CONTACT_VALUE_FRAGMENT = `
  ... on ScalarContact { val }
  ... on AddressContact {
    building unit streetNumber streetName postalDeliveryInfo
    locality region postcode country countryId
    formattedAddress addressValidation addressValidationSource
  }
`;

export const GET_ENTITIES = `
  query GetEntities {
    entities {
      id name code isActive studentCount
    }
  }
`;

export const GET_STUDENTS_BY_ENTITY = `
  query GetStudentsByEntity($entityId: ID!) {
    studentsByEntity(entityId: $entityId) {
      id firstName lastName fullName gender birthDate isActive entityId
      contacts { id }
    }
  }
`;

export const GET_CURRENT_USER_PROFILE = `
  query GetCurrentUserProfile {
    getCurrentUserProfile {
      id firstName lastName fullName gender birthDate isActive entityId
      contacts {
        id userId typeId rank isActive isRecovery bounced bounceCount
        lastBounced activeFrom activeTo createdAt updatedAt
        contactValue { ${CONTACT_VALUE_FRAGMENT} }
        contactType { id name isAddressType isActive }
      }
    }
  }
`;

export const GET_USER_PROFILE = `
  query GetUserProfile($userId: ID!) {
    getUserProfile(userId: $userId) {
      id firstName lastName fullName gender birthDate isActive entityId
      contacts {
        id userId typeId rank isActive isRecovery bounced bounceCount
        lastBounced activeFrom activeTo createdAt updatedAt
        contactValue { ${CONTACT_VALUE_FRAGMENT} }
        contactType { id name isAddressType isActive }
      }
    }
  }
`;

export const GET_CONTACTS = `
  query GetContacts($userId: ID!, $typeId: Int, $activeOnly: Boolean) {
    contacts(userId: $userId, typeId: $typeId, activeOnly: $activeOnly) {
      id userId typeId rank isActive isRecovery bounced bounceCount
      lastBounced activeFrom activeTo createdAt updatedAt
      contactValue { ${CONTACT_VALUE_FRAGMENT} }
      contactType { id name isAddressType isActive }
    }
  }
`;

export const GET_PRIMARY_CONTACT = `
  query GetPrimaryContact($userId: ID!, $typeId: Int!) {
    primaryContact(userId: $userId, typeId: $typeId) {
      id userId typeId rank isActive isRecovery bounced bounceCount
      contactValue { ${CONTACT_VALUE_FRAGMENT} }
    }
  }
`;
